$(document).ready(function () {
    $("#cart-submit-button, #cart-submit-button-top").on('click', function( event ) {
        event.preventDefault();
        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
            url: '/submit/cart',
            type: 'POST',
            data: $("#submit-cart-form").serialize(),
            beforeSend: function(xhr) {
                xhr.setRequestHeader(header, token);
            },
            success: function (response) {
                if(response.status == "SUCCESS"){
                    window.location.href = response.redirectLink;
                }
                if(response.status == "INVALID_PROPERTIES"){
                    errorInfo = "";
                    for(i =0 ; i < response.errorMessages.length ; i++){
                       errorInfo += "<div class='text text-danger'>" + response.errorMessages[i]+"</div>";
                    }
                    for(i =0 ; i < response.cartEntryProperties.length ; i++){
                       errorInfo += "<div class='text text-danger'> * " + response.cartEntryProperties[i].title+"</div>";
                    }
                    $('#cart-property-errors').html(errorInfo);
                    $("#cart-property-errors").show();

                }
            }
        });
    });
});